import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeQuotes',
})
export class RemoveQuotesPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"') {
      value = value.substr(1, value.length - 2);
    }

    return value;
  }
}
